import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import UltraVioletCredentialsForm from "./UltraVioletCredentialsForm";
import UltraVioLetConfigLising from "./UltraVioletConfigListing";

export default function UltraVioletPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={UltraVioletCredentialsForm}
      PullConfigListingView={UltraVioLetConfigLising}
    />
  );
}